// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d1e7d8f1","620":"e894002c"}[chunkId] + ".chunk.js";
};